import { render, staticRenderFns } from "./MapsSidebarButtons.vue?vue&type=template&id=0b21bb8b&"
import script from "./MapsSidebarButtons.vue?vue&type=script&lang=ts&"
export * from "./MapsSidebarButtons.vue?vue&type=script&lang=ts&"
import style0 from "./MapsSidebarButtons.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports